/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AzureResourceGroupStore } from 'src/core/stores/AzureResourceGroupStore';
import { AzureSearchStore } from 'src/core/stores/AzureSearchStore';
import { AzureSessionStore } from 'src/core/stores/AzureSessionStore';
import { AzureStorageAccountStore } from 'src/core/stores/AzureStorageAccountStore';
import { AzureSubscriptionStore } from 'src/core/stores/AzureSubscriptionStore';
import { AzureTenantStore } from 'src/core/stores/AzureTenantStore';
import { ProgressTrackerStore } from 'src/core/stores/ProgressTrackerStore';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';

export class AzureStore {
    public readonly session: AzureSessionStore;

    public readonly loadingState: ProgressTrackerStore;

    public readonly tenantStoreHouse: ResourceStoreHouse<AzureTenantStore>;

    public readonly subscriptionStoreHouse: ResourceStoreHouse<AzureSubscriptionStore>;

    public readonly resourceGroupStoreHouse: ResourceStoreHouse<AzureResourceGroupStore>;

    public readonly storageAccountStoreHouse: ResourceStoreHouse<AzureStorageAccountStore>;

    public readonly searchServicesStoreHouse: ResourceStoreHouse<AzureSearchStore>;

    constructor() {
        this.session = new AzureSessionStore();
        this.loadingState = new ProgressTrackerStore();
        this.tenantStoreHouse = createResourceStoreHouse();
        this.subscriptionStoreHouse = createResourceStoreHouse();
        this.resourceGroupStoreHouse = createResourceStoreHouse();
        this.storageAccountStoreHouse = createResourceStoreHouse();
        this.searchServicesStoreHouse = createResourceStoreHouse();
    }
}
